"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = exports.DRAWER_EDGE_ITEM_TYPE = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var react_simple_cookie_store_1 = require("react-simple-cookie-store");
var react_1 = __importStar(require("react"));
var DrawerGroup_1 = require("./DrawerGroup");
var DrawerItem_1 = require("./DrawerItem");
var Navigation_1 = require("../Navigation");
var Form_1 = require("../Form");
var Form_2 = require("../Form");
var types_1 = require("./types");
var clsx_1 = __importDefault(require("clsx"));
var DrawerBackground_1 = require("./DrawerBackground");
var DraggableEdge_1 = require("./DraggableEdge");
var utils_1 = require("utils");
var Indicators = __importStar(require("../Indicators"));
var utils_2 = require("utils");
exports.DRAWER_EDGE_ITEM_TYPE = "DrawerEdgeItem";
var WIDTH_COOKIE = "drawerWidth";
var DRAWER_STYLES = "flex flex-col bg-white h-full relative shadow-lg";
var BAR_TEXT_COLOR = "text-lochivar-dark";
var BAR_STYLES = "flex border-b border-lochivar-default border-opacity-25 bg-lochivar-default bg-opacity-5 p-1";
var Drawer = function (_a) {
    var _b;
    var title = _a.title, items = _a.items, handleSort = _a.onSort, handleSearch = _a.onSearch, handleNewClick = _a.onNewClick, handleNewGroupClick = _a.onNewGroupClick, handleDismiss = _a.onDismiss, handleToggleGroup = _a.onToggleGroup, onContextMenu = _a.onContextMenu, newItemLabel = _a.newItemLabel, offset = _a.offset, loading = _a.loading;
    var _c = (0, react_1.useState)(null), altAction = _c[0], setAltAction = _c[1];
    var _d = (0, react_1.useState)(parseInt((_b = (0, react_simple_cookie_store_1.getCookie)(WIDTH_COOKIE)) !== null && _b !== void 0 ? _b : "425")), width = _d[0], setWidth = _d[1];
    var _e = (0, react_1.useState)(""), search = _e[0], setSearch = _e[1];
    var handleChange = function (e) {
        var searchText = e.currentTarget.value;
        setSearch(searchText);
        handleSearch === null || handleSearch === void 0 ? void 0 : handleSearch(searchText);
    };
    var breakpoints = (0, utils_1.useBreakpoint)();
    var searchInput = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var _a;
        (_a = searchInput.current) === null || _a === void 0 ? void 0 : _a.focus();
        if (altAction !== "search") {
            setSearch("");
            handleSearch === null || handleSearch === void 0 ? void 0 : handleSearch("");
        }
    }, [searchInput.current, altAction]);
    var toggleAction = function (action) { return function () {
        setAltAction(action);
    }; };
    var sortable = altAction === "sort";
    var truncationLength = Math.round((width - 100) / 7);
    var renderTree = function (groupId, indent) {
        var indentedTruncationLength = truncationLength
            ? truncationLength - (indent !== null && indent !== void 0 ? indent : 0) * 5
            : undefined;
        return ((0, jsx_runtime_1.jsx)("ul", __assign({ className: "flex flex-col w-full" }, { children: items
                .filter(function (i) { return (groupId ? i.groupId === groupId : !i.groupId); })
                .map(function (_a) {
                var id = _a.id, item = __rest(_a, ["id"]);
                var isGroup = item.type === types_1.DRAWER_GROUP_TYPE;
                var selectGroup = function (e) {
                    var _a;
                    e.preventDefault();
                    handleToggleGroup === null || handleToggleGroup === void 0 ? void 0 : handleToggleGroup(id, !((_a = item.open) !== null && _a !== void 0 ? _a : false));
                };
                var renderContent = function () {
                    return isGroup ? ((0, jsx_runtime_1.jsx)(DrawerGroup_1.DrawerGroup, __assign({}, item, { id: id, sortable: sortable, indent: indent, onSelect: selectGroup, onSort: handleSort, onContextMenu: onContextMenu, truncationLength: indentedTruncationLength }), void 0)) : ((0, jsx_runtime_1.jsx)(DrawerItem_1.DrawerItem, __assign({}, item, { id: id, sortable: sortable, indent: indent, onSort: handleSort, onContextMenu: onContextMenu, truncationLength: indentedTruncationLength }), void 0));
                };
                var canRenderSubtree = id &&
                    isGroup &&
                    item.open &&
                    item.id !== id &&
                    (indent !== null && indent !== void 0 ? indent : 0) < 20;
                return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [renderContent(), canRenderSubtree ? renderTree(id, (indent !== null && indent !== void 0 ? indent : 0) + 1) : null] }, id));
            }) }), void 0));
    };
    var handleDragOver = (0, react_1.useCallback)(function (delta) {
        var newWidth = Math.min(Math.max(delta - (offset !== null && offset !== void 0 ? offset : 0), 225), 768);
        setWidth(newWidth);
        (0, react_simple_cookie_store_1.setCookie)(WIDTH_COOKIE, newWidth.toString(), 365);
    }, [width, setWidth]);
    var focusSearch = function () {
        var _a;
        (_a = searchInput.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var stopClick = function (e) {
        e.stopPropagation();
        e.preventDefault();
    };
    return ((0, jsx_runtime_1.jsx)(DrawerBackground_1.DrawerBackground, __assign({ onClick: handleDismiss, onDragOver: handleDragOver }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: DRAWER_STYLES, style: {
                width: breakpoints.includes("md") ? width : "100%",
                left: offset,
            }, onClick: stopClick }, { children: [loading ? (0, jsx_runtime_1.jsx)(Indicators.AbsoluteOverlay, {}, void 0) : null, (0, jsx_runtime_1.jsx)(DraggableEdge_1.DraggableEdge, {}, void 0), (0, jsx_runtime_1.jsxs)("header", { children: [altAction === "sort" ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)(BAR_TEXT_COLOR, BAR_STYLES) }, { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ className: "my-auto font-bold mr-auto ml-2" }, { children: "Drag and drop to sort" }), void 0), (0, jsx_runtime_1.jsx)(Form_1.Button, __assign({ onClick: (0, utils_2.swallow)(toggleAction(null)), appearance: "link", className: "my-auto mx-2" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "mx-auto" }, { children: "Done" }), void 0) }), void 0), (0, jsx_runtime_1.jsx)(Navigation_1.IconButton, { onClick: toggleAction(null), icon: pro_regular_svg_icons_1.faCheckCircle, tooltip: "Done", className: "my-auto" }, void 0)] }), void 0)) : null, altAction ? null : ((0, jsx_runtime_1.jsxs)("ul", __assign({ className: (0, clsx_1.default)(BAR_TEXT_COLOR, BAR_STYLES) }, { children: [handleSearch ? ((0, jsx_runtime_1.jsx)("li", __assign({ className: "flex mr-1" }, { children: (0, jsx_runtime_1.jsx)(Navigation_1.IconButton, { icon: pro_regular_svg_icons_1.faSearch, onClick: focusSearch, tooltip: "search", className: "my-auto" }, void 0) }), void 0)) : null, (0, jsx_runtime_1.jsx)("li", __assign({ className: "flex flex-grow my-auto mr-auto text-small font-bold" }, { children: (0, jsx_runtime_1.jsx)(Form_2.Input, { placeholder: "search " + title.toLowerCase() + "...", onChange: handleChange, value: search, name: "searchText", className: "w-full mx-1", ref: searchInput }, void 0) }), void 0), handleSort ? ((0, jsx_runtime_1.jsx)("li", __assign({ className: "flex" }, { children: (0, jsx_runtime_1.jsx)(Form_1.Button, __assign({ onClick: (0, utils_2.swallow)(toggleAction("sort")), appearance: "link", className: "my-auto mx-1" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "mx-auto" }, { children: "Sort" }), void 0) }), void 0) }), void 0)) : null, handleDismiss ? ((0, jsx_runtime_1.jsx)("li", __assign({ className: "flex" }, { children: (0, jsx_runtime_1.jsx)(Navigation_1.IconButton, { icon: pro_regular_svg_icons_1.faTimes, onClick: handleDismiss, tooltip: "close", className: "my-auto" }, void 0) }), void 0)) : null] }), void 0))] }, void 0), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex-grow relative" }, { children: (0, jsx_runtime_1.jsxs)("nav", __assign({ className: "absolute inset-0 overflow-y-auto" }, { children: [handleNewClick || handleNewGroupClick ? ((0, jsx_runtime_1.jsxs)("header", __assign({ className: "flex p-2 border-b border-gray-200 sticky top-0 bg-white z-10" }, { children: [handleNewClick ? ((0, jsx_runtime_1.jsx)(Form_1.Button, __assign({ onClick: handleNewClick, className: "mr-1 flex flex-grow flex-shrink-0" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "mx-auto" }, { children: newItemLabel !== null && newItemLabel !== void 0 ? newItemLabel : "Add Item" }), void 0) }), void 0)) : null, handleNewGroupClick ? ((0, jsx_runtime_1.jsx)(Form_1.Button, __assign({ onClick: handleNewGroupClick, className: "ml-1 flex flex-grow flex-shrink-0" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "mx-auto" }, { children: "New Group" }), void 0) }), void 0)) : null] }), void 0)) : null, renderTree()] }), void 0) }), void 0)] }), void 0) }), void 0));
};
exports.Drawer = Drawer;
